import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _WorkActivitySubtask } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { CardTaps } from "../../../../../../theme/Component/CardTaps";
import { WorkActivityNotes } from "../../../../../WorkActivity/WorkActivityNotes/WorkActivityNotes";
import "./ActivityCardInfo.css"
import { WorkActivityRelationGroup } from "../../../../../WorkActivity/WorkActivityRelationGroup/WorkActivityGroupRelation";

type WorkActivity = {
  IDWorkActivity: number;
  IDSprint: number;
  [key: string]: any;
};

type WorkActivitySubTask = {
  [key: string]: any;
};

interface ActivityCard {
  WorkActivity: WorkActivity;
}



export const ActivityCardInfo = ({ WorkActivity }: ActivityCard) => {

  const { instance: instanceSubT, lista: listaSubT, setLista: setListaSubT, bean: beanSubT, setBean: setBeanSubT } = useDataBean(_WorkActivitySubtask)

  const p = WorkActivity;
  const total = listaSubT?.length || 0;
  const completed = listaSubT?.filter(x => x.DataBeanProperties.IsCompleted)?.length || 0;
  const progress = total > 0 ? (completed / total) * 100 : 0;

  const [newSubtask, setNewSubtask] = useState<Partial<WorkActivitySubTask>>({
    IDWorkActivity: p.IDWorkActivity,
    IsCompleted: false,
    State: 1,
    Name: "",
    Description: ""
  });
  const [indexTap, setIndexTap] = useState(0);

  const taps = [
    { id: 0, name: 'Sub-Tareas', disable: false },
    { id: 1, name: 'Notas', disable: false },
    { id: 2, name: 'Grupos', disable: false }
  ];

  useEffect(() => {
    if (p.IDWorkActivity) {
      getSubTaskLista()
    }
  }, [p.IDWorkActivity])

  const getSubTaskLista = () => {
    const props = {
      IDWorkActivity: p.IDWorkActivity,
      State: 1
    }
    instanceSubT.getWorkActivitySubtaskCatalogPorPropiedades(props, null).then(
      (resp) => {
        setListaSubT(resp);
      }
    ).catch(
      err => { toast.error(err) }
    )
  }

  const checkItem = (obj: WorkActivitySubTask) => {
    const x = {
      ...obj,
      IsCompleted: !obj.IsCompleted
    };

    editaItem(x);
  };

  const deleteItem = (obj: WorkActivitySubTask) => {
    const x = { ...obj, State: 2 };
    editaItem(x);
  };

  const editaItem = (obj: WorkActivitySubTask) => {
    instanceSubT.updateWorkActivitySubtask(obj).then(
      (resp: any) => {
        getSubTaskLista();
        setNewSubtask({ ...newSubtask, Name: "", Description: "" })
      }
    ).catch(err => {
      toast.error(err);
    })
  }

  return (
    <div className="activity-detail">

      {/* DESCRIPCIÓN */}
      <div className="activity-detail__section">
        <h6>Descripción</h6>
        <p>{p.Description || "Sin descripción"}</p>
      </div>

      {/* GRID INFO */}
      <div className="activity-detail__grid">

        <div>
          <strong>Tipo:</strong>
          <span>{p.ActivityTypeName}</span>
        </div>

        <div>
          <strong>Prioridad:</strong>
          <span>{p.PriorityName}</span>
        </div>

        <div>
          <strong>Responsable:</strong>
          <span>{p.AccountFullName || "Sin asignar"}</span>
        </div>

        <div>
          <strong>Reportado por:</strong>
          <span>{p.AccountReporterFullName}</span>
        </div>

        <div>
          <strong>Fecha creación:</strong>
          <span>{p.FromDate}</span>
        </div>

      </div>

      <hr />
      <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
        {indexTap === 0 &&
          <>
            <div className="activity-subtasks">
              <h4>Sub-tareas ({completed}/{total})</h4>

              <div className="subtask-create">
                <input
                  type="text"
                  placeholder="Nombre de la subtarea..."
                  className="form-control"
                  value={newSubtask.Name}
                  onChange={(e) =>
                    setNewSubtask({ ...newSubtask, Name: e.target.value })
                  }
                />

                <input
                  type="text"
                  placeholder="Descripción..."
                  className="form-control"
                  value={newSubtask.Description}
                  onChange={(e) =>
                    setNewSubtask({ ...newSubtask, Description: e.target.value })
                  }
                />

                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    if (!newSubtask.Name) {
                      toast.warning("El nombre es obligatorio");
                      return;
                    }

                    editaItem(newSubtask);
                  }}
                >
                  +
                </button>
              </div>

              <div className="subtask-list">
                {listaSubT?.map((item) => {
                  const sub = item.DataBeanProperties;

                  return (
                    <div
                      key={sub.IDWorkActivitySubtask}
                      className={`subtask-item ${sub.IsCompleted ? "completed" : ""}`}
                    >
                      {/* CHECK */}
                      <input
                        type="checkbox"
                        checked={sub.IsCompleted}
                        onChange={() => { checkItem(sub) }}
                      />

                      {/* INFO */}
                      <div className="subtask-content">
                        <span className="subtask-title">{sub.Name}</span>
                        <small>{sub.Description}</small>
                      </div>

                      {/* ACTIONS */}
                      <div className="subtask-actions">
                        <button className="btn btn-danger btn-sm" onClick={() => { deleteItem(sub) }}>
                          <i className="ri-delete-bin-line fs-12"></i>
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="activity-detail__progress">
              <div
                className="activity-detail__progress-bar"
                style={{ width: `${progress}%` }}
              />
            </div>
          </>
        }

        {indexTap === 1 &&
          <WorkActivityNotes WorkActivity={p} canUse />
        }

        {indexTap === 2 &&
          <WorkActivityRelationGroup Sprint={p} />
        }

      </CardTaps>
    </div>
  );
};